
import type { Resource } from '../types/resources';

export default (resources: Resource[]) => {
  if (!Array.isArray(resources))
    throw new Error('(SS12000::From::Resources) Resources input is not of array type', { cause: 'invalid_input' });

  return resources.map((resource) => ({
    ids: resource.id,
  }));
};
